import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from "react-router-dom"
import App from './App'
import * as serviceWorker from './serviceWorker'
import AuthDataProvider from './_providers/Auth'
import LanguageProvider from './_providers/Language'
import CurrencyProvider from './_providers/Currency'
import TranslationProvider from './_providers/Translation'
import { createBrowserHistory } from 'history'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SnackbarProvider } from 'notistack'

const history = createBrowserHistory()

const container = document.getElementById('root')
const root = createRoot(container)

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: false,
        },
    },
})

root.render(
    <Router history={history}>
        <QueryClientProvider client={queryClient}>
            <SnackbarProvider maxSnack={3}>
                <AuthDataProvider>
                    <LanguageProvider>
                        <TranslationProvider>
                            <CurrencyProvider>
                                <App />
                            </CurrencyProvider>
                        </TranslationProvider>
                    </LanguageProvider>
                </AuthDataProvider>
            </SnackbarProvider>
        </QueryClientProvider>
    </Router>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
